import axios from 'axios';
import React from 'react';
import '../styles/AuthMethodButtons.css';
import { isAbortError } from '../isAbortError.js';
import { useAbortController } from '../../Shared/hooks/useAbortController.js';
import { saveAuthReturnTo, validateReturnTo } from '../../Shared/utils/authReturnTo.js';

export default function FacebookLoginButton({ withoutAction, returnTo }) {
    const { nextSignal } = useAbortController();

    const handleLoginClick = async (event) => {
        event.preventDefault();
        if (withoutAction) return;

        const validatedReturnTo = validateReturnTo(returnTo);
        if (validatedReturnTo) {
            saveAuthReturnTo(validatedReturnTo);
        }

        try {
            const authUrl = validatedReturnTo
                ? `${import.meta.env.VITE_BASE_URL}/auth/facebook?returnTo=${encodeURIComponent(validatedReturnTo)}`
                : `${import.meta.env.VITE_BASE_URL}/auth/facebook`;

            const response = await axios.get(authUrl, {
                signal: nextSignal('facebook-auth'),
            });
            window.location.href = response.data;
        } catch (error) {
            if (!isAbortError(error)) {
                console.error('Error fetching Facebook auth URL', error);
            }
        }
    };

    return (
        <button type="button" className="auth-method__button" onClick={handleLoginClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none" viewBox="0 0 35 35">
                <defs>
                    <clipPath id="clip229_165">
                        <path fill="#fff" fillOpacity="0" d="M0 0H35V35H0z"></path>
                    </clipPath>
                </defs>
                <g fillOpacity="1" fillRule="nonzero" clipPath="url(#clip229_165)">
                    <path fill="#1877F2" d="M35 17.5C35 7.83 27.16 0 17.5 0 7.83 0 0 7.83 0 17.5c0 8.73 6.39 15.97 14.76 17.28V22.55h-4.44V17.5h4.44v-3.86c0-4.39 2.61-6.81 6.61-6.81 1.92 0 3.92.34 3.92.34v4.31h-2.21c-2.17 0-2.85 1.35-2.85 2.73v3.29h4.85l-.77 5.05h-4.08v12.23C28.6 33.47 35 26.23 35 17.5z"></path>
                    <path fill="#FFF" d="M24.31 22.55l.77-5.05h-4.85v-3.29c0-1.38.68-2.73 2.85-2.73h2.21V7.17s-2-.34-3.92-.34c-4 0-6.61 2.42-6.61 6.81v3.86h-4.44v5.05h-4.44v12.23c.91.14 1.82.22 2.74.22.91 0 1.82-.08 2.73-.22V22.55h4.08z"></path>
                </g>
            </svg>
            <p>
                Sign up with Facebook
            </p>
        </button>
    );
}
